'use strict';/* global define */define('modules/core/modules/utils/services/volatile-storage/index',['require','exports','module'],function(require,exports,module){'use strict';var _items={};// @ngInject
function factory(){// jshint validthis:true
// jshint latedef:false
return{//we have to use a getter function for length, in order to make it behave like a property
//cf. https://developer.mozilla.org/en-US/docs/Web/API/Storage
get length(){return _length();},key:key,getItem:getItem,setItem:setItem,removeItem:removeItem,clear:clear};// ---
/**
     * The length read-only property of the Storage interface returns an integer representing the number of data items stored in the Storage object.
     *
     * @return {number} - number of items
     *
     * @tested
     */function _length(){return Object.keys(_items).length;}/**
     * The key() method of the Storage interface, passed a number n, will return the name of the nth key in the storage.
     * The order of keys is user-agent defined, so you should not rely on it.
     *
     * @param  {number} - key id
     * @return {string} - i-th key name OR null, if key is not stored
     *
     * @tested
     */function key(i){var keys=Object.keys(_items);var length=keys.length;if(i<length){return keys[i];}else{return null;}}/**
     * The getItem() method of the Storage interface, when passed a key name, will return that key's value.
     *
     * @param  {string} - key name
     * @return {string} - key value OR null, if key is not stored
     *
     * @tested
     */function getItem(key){return _items[key]||null;}/**
     * The setItem() method of the Storage interface, when passed a key name and value, will add that key to the storage, or update that key's value if it already exists.
     *
     * @param  {string} - key name
     * @param  {string} - key value
     *
     * @tested
     */function setItem(key,value){_items[key]=value.toString();}/**
     * The removeItem() method of the Storage interface, when passed a key name, will remove that key from the storage.
     *
     * @param  {string} - key name
     *
     * @tested
     */function removeItem(key){delete _items[key];}/**
     * The clear() method of the Storage interface, when invoked, will empty all keys out of the storage.
     *
     * @tested
     */function clear(){_items={};}}module.exports=factory;});
